import { storeEatData } from "../data/store_eat";
import { storeLiveData } from "../data/store_live";
import { storePlayData } from "../data/store_play";
import { storeBuyData } from "../data/store_buy";

const isPixnetLink = (url = "") => /^https?:\/\/([a-z0-9-]+\.)?pixnet\.net\//i.test(url);

const toArticleCards = (items, prefix, categoryLabel) => {
    return items
        .filter((item) => isPixnetLink(item.link))
        .map((item) => ({
            id: `${prefix}-${item.id}`,
            title: item.name,
            content: `${item.area} ${categoryLabel}精選推薦`,
            image: item.image,
            link: item.link
        }));
};

const toHashtagItems = (groups) => {
    return groups.flatMap(({ prefix, items }) => (
        items
            .filter((item) => isPixnetLink(item.link))
            .map((item) => ({
                id: `${prefix}-${item.id}`,
                title: item.name,
                image: item.image,
                link: item.link
            }))
    ));
};

const staticData = {
    _meta: {
        isBootstrap: false,
        generatedAt: "2026-03-18T00:00:00.000Z",
        source: "local-curated-store-data"
    },
    articlesEat: toArticleCards(storeEatData, "eat", "潮好吃"),
    articlesLive: toArticleCards(storeLiveData, "live", "潮好住"),
    articlesPlay: toArticleCards(storePlayData, "play", "潮好玩"),
    articlesBuy: toArticleCards(storeBuyData, "buy", "潮好買"),
    hashtagWall: toHashtagItems([
        { prefix: "eat", items: storeEatData },
        { prefix: "live", items: storeLiveData },
        { prefix: "play", items: storePlayData },
        { prefix: "buy", items: storeBuyData }
    ])
};

export default staticData;
